import HomePageFooter from './HomePageFooter';

export default HomePageFooter;
